var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import Loader from '../Loader';
var IFrame = function (props) {
    var height = props.height, on3dsResponse = props.on3dsResponse, onRedirectUrl = props.onRedirectUrl, on3dsRedirect = props.on3dsRedirect, on3dsFail = props.on3dsFail, onCardSaved = props.onCardSaved, onFocus = props.onFocus, isAllInputsValid = props.isAllInputsValid, onTokenCreated = props.onTokenCreated, onBin = props.onBin, showLoadingState = props.showLoadingState, onReady = props.onReady, wrapperHeaderHeight = props.wrapperHeaderHeight, themeMode = props.themeMode, onIFrameLoaded = props.onIFrameLoaded, onError = props.onError, framePath = props.framePath, showLoader = props.showLoader, hideSpinnerLoader = props.hideSpinnerLoader, onCompleteTyping = props.onCompleteTyping, onDetectBrand = props.onDetectBrand, onChangeSaveCardLater = props.onChangeSaveCardLater, onChangeSaveCardLaterTap = props.onChangeSaveCardLaterTap, onResetLoadedCard = props.onResetLoadedCard;
    var _a = React.useState(height), dynamicHeight = _a[0], setDynamicHeight = _a[1];
    var _b = React.useState(height), cardInputsHeight = _b[0], setCardInputsHeight = _b[1];
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useState(false), is3ds = _d[0], setIs3ds = _d[1];
    var onCardReady = function () {
        onReady && onReady();
    };
    var onIframeReady = function () {
        onIFrameLoaded && onIFrameLoaded();
    };
    var setIframeHeight = function (height) {
        if (!height)
            return;
        setDynamicHeight(height);
    };
    var setCardInputsHeightHandler = function (height) {
        if (!height)
            return;
        setCardInputsHeight(height);
    };
    var globalEventHandler = React.useCallback(function (e) {
        var _a = e.data, data = _a.data, event = _a.event;
        if (data === undefined)
            return;
        if (event === 'cardInputs' && isAllInputsValid) {
            if (data.isAllInputsValid === undefined)
                return;
            return isAllInputsValid(!!data.isAllInputsValid);
        }
        if (event === 'token' && onTokenCreated) {
            return onTokenCreated(data.token, data.redirectUrl);
        }
        if (event === 'bin' && onBin) {
            return onBin(data.bin);
        }
        if (event === 'focused' && onFocus) {
            return onFocus(data.focused);
        }
        if (event === 'saveCardForLater' && onChangeSaveCardLater) {
            return onChangeSaveCardLater(data.saveCardForLater);
        }
        if (event === 'saveCardForLaterTap' && onChangeSaveCardLaterTap) {
            return onChangeSaveCardLaterTap(data.saveCardForLaterTap);
        }
        if (event === 'resetLoadedCard' && onResetLoadedCard) {
            return onResetLoadedCard();
        }
        if (event === 'savedCard' && onCardSaved) {
            return onCardSaved(data.card);
        }
        if (event === '3dsRedirect' && on3dsRedirect) {
            return on3dsRedirect(data.threeDsRedirect);
        }
        if (event === '3dsFail' && on3dsFail) {
            return on3dsFail(data.threeDsFail);
        }
        if (event === 'redirectUrl' && onRedirectUrl) {
            return onRedirectUrl(data.redirectUrl);
        }
        if (event === '3dsResponse' && on3dsResponse) {
            return on3dsResponse(data.threeDsResponse);
        }
        if (event === 'brand' && onDetectBrand) {
            onDetectBrand(data.brand);
        }
        if (event === 'onCardReady') {
            onCardReady();
        }
        if (event == 'dimension') {
            var height_1 = data.height, inputsHeight = data.inputsHeight;
            setIframeHeight(height_1);
            setCardInputsHeightHandler(inputsHeight);
        }
        if (event == '3dsRedirect') {
            setIs3ds(true);
            setLoading(true);
        }
        if (event == '3dsResponse' || event == '3dsFail' || event == 'savedCard') {
            setIs3ds(false);
        }
        if (event == 'loadingIframe') {
            console.log('loadingIframe', data);
            setLoading(data);
        }
        if (event == 'error' && onError) {
            onError(data);
        }
        if (event === 'completeTyping' && onCompleteTyping) {
            onCompleteTyping(data.completeTyping);
        }
    }, []);
    React.useEffect(function () {
        window.addEventListener('message', globalEventHandler, false);
        return function () { return window.removeEventListener('message', globalEventHandler); };
    }, [globalEventHandler]);
    var threeDsStyle = {
        borderRadius: 8,
        width: '-webkit-fill-available'
    };
    var cardPointerEvents = showLoader === undefined ? (loading ? 'none' : 'auto') : showLoader ? 'none' : 'auto';
    var cardLoading = showLoader === undefined ? loading : showLoader;
    var cardHideSpinnerLoader = hideSpinnerLoader === undefined ? showLoadingState === false : hideSpinnerLoader;
    console.log('cardLoading', cardLoading);
    console.log('cardHideSpinnerLoader', cardHideSpinnerLoader);
    return (_jsxs("div", __assign({ style: __assign(__assign({ width: '100%', marginLeft: 'auto', boxSizing: 'border-box', marginRight: 'auto', display: 'flex', maxWidth: '500px', padding: '0px !important', position: 'relative', background: 'inherit' }, (is3ds && threeDsStyle)), { pointerEvents: cardPointerEvents, transition: 'all ease-out 0.05s' }) }, { children: [_jsx(Loader, { hideSpinnerLoader: cardHideSpinnerLoader, loading: !!cardLoading, height: cardInputsHeight, themeMode: themeMode, is3ds: is3ds }), _jsx("iframe", { id: 'tap-card-iframe', name: 'tapFrame', title: 'Secure payment input', width: '100%', allowFullScreen: true, referrerPolicy: 'origin', frameBorder: '0', style: __assign(__assign({ border: 'none', margin: '0px', padding: '0px', minWidth: '100%', overflow: 'block', height: "".concat(dynamicHeight, "px"), width: '100%' }, (is3ds && __assign(__assign(__assign({}, threeDsStyle), { backgroundColor: 'inherit' }), (wrapperHeaderHeight && { maxHeight: "calc(100vh - ".concat(wrapperHeaderHeight + 40, "px)"), overflow: 'auto' })))), { transition: 'all ease-out 0.05s' }), onLoad: onIframeReady, src: framePath })] })));
};
export default React.memo(IFrame);
